(function () {
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    return (format || '€{{amount_with_comma_separator}}').replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Productgalerij
    document.querySelectorAll('[data-hn-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('.hn-main-img');
      gallery.querySelectorAll('[data-hn-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!main) return; main.src = btn.getAttribute('data-src');
          main.alt = btn.getAttribute('data-alt') || '';
          gallery.querySelectorAll('[data-hn-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
          btn.setAttribute('aria-current', 'true');
        });
      });
    });

    // Variantkeuze
    document.querySelectorAll('[data-hn-product]').forEach(function (form) {
      var dataEl = form.querySelector('script[type="application/json"]');
      var select = form.querySelector('[data-hn-variant]');
      if (!dataEl || !select) return;
      var data = JSON.parse(dataEl.textContent);
      var priceEl = document.querySelector('[data-hn-price]');
      var btn = form.querySelector('[type="submit"]');
      select.addEventListener('change', function () {
        var v = data.variants.find(function (x) { return String(x.id) === select.value; });
        if (!v) return;
        if (priceEl) {
          priceEl.innerHTML = formatMoney(v.price, data.money_format) +
            (v.compare_at_price > v.price ? ' <s>' + formatMoney(v.compare_at_price, data.money_format) + '</s>' : '');
        }
        if (btn) {
          btn.disabled = !v.available;
          btn.textContent = v.available ? 'In winkelmand' : 'Uitverkocht';
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      });
    });
  });
})();
